<template>
  <div class="supportH5" ref="supportH5">
    <!-- Hero Banner -->
    <div class="hero-section">
      <img class="hero-illustration" v-lazy="require('@/assets/help/h5-hero-bg-6d0c75.png')" alt="" />
    </div>

    <!-- 我的服务能力 -->
    <div class="section service-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('我们的服务能力') }}</h2>
        <p class="section-desc">{{ $t('提供多场景解决方案，满足各行业客户的业务需求，') }}<br />{{ $t('快速实现数字化转型') }}</p>
      </div>
      <div class="service-grid">
        <div class="service-card" v-for="item in serviceList" :key="item.title">
          <img class="service-icon" v-lazy="item.icon" alt="" />
          <div class="service-info">
            <h3 class="service-title">{{ item.title }}</h3>
            <p class="service-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 多种支持方式 -->
    <div class="section support-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('多种支持方式，快速为您解决问题') }}</h2>
      </div>
      <div class="support-cards">
        <div class="support-card wechat-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-wechat.svg')" alt="" />
          <h3 class="support-title green">{{ $t('在线客服') }}</h3>
          <p class="support-desc">{{ $t('实时在线沟通，快速响应') }}<br />{{ $t('微信/企微客服，方便快捷') }}</p>
          <div class="support-btn green-btn" @click="phone">{{ $t('立即咨询') }}</div>
        </div>
        <div class="support-card ticket-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-ticket.svg')" alt="" />
          <h3 class="support-title purple">{{ $t('提交工单') }}</h3>
          <p class="support-desc">{{ $t('详细描述问题，专人跟进') }}<br />{{ $t('问题跟踪处理，进度可查') }}</p>
          <span class="support-tag purple-tag">{{ $t('代理商专属') }}</span>
        </div>
        <div class="support-card phone-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-phone-support.svg')" alt="" />
          <h3 class="support-title blue">{{ $t('电话支持') }}</h3>
          <p class="support-desc">{{ $t('电话一对一服务，专业高效') }}<br />{{ $t('工作时间：') }}<br />9:00 - 21:00</p>
          <span class="support-tag blue-tag">400-086-1123</span>
        </div>
      </div>
    </div>

    <!-- 服务流程 -->
    <div class="section flow-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('服务流程') }}</h2>
      </div>
      <div class="flow-steps">
        <template v-for="(step, index) in flowSteps">
          <div class="flow-step" :key="step.num">
            <img class="step-icon" v-lazy="step.icon" alt="" />
            <span class="step-title">{{ step.title }}</span>
          </div>
          <img
            v-if="index < flowSteps.length - 1"
            :key="'arrow-' + step.num"
            class="step-arrow"
            v-lazy="require('@/assets/help/h5-step-arrow.png')"
            alt=""
          />
        </template>
      </div>
    </div>

    <!-- 服务保障 -->
    <div class="section guarantee-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('服务保障') }}</h2>
        <p class="section-desc">{{ $t('数十年的行业服务经营，做商家服务领域最值得信赖的伙伴') }}</p>
      </div>
      <div class="guarantee-grid">
        <div class="guarantee-card" v-for="item in guaranteeList" :key="item.value">
          <div class="guarantee-head">
            <img class="guarantee-icon" v-lazy="item.icon" alt="" />
            <span class="guarantee-value">{{ item.value }}</span>
          </div>
          <div class="guarantee-label">{{ item.label }}</div>
          <p class="guarantee-desc" v-html="item.desc"></p>
        </div>
      </div>
    </div>

    <!-- 服务亮点 -->
    <div class="feature-bar">
      <div class="feature-list">
        <div class="feature-item" v-for="text in heroFeatures" :key="'bar-' + text">
          <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
          <span>{{ text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from "@/i18n";

export default {
  data() {
    return {
      heroFeatures: [t("7x12小时响应"), t("专业技术团队"), t("全流程售后保障")],
      serviceList: [
        {
          icon: require("@/assets/help/icon-service.svg"),
          title: t("专业客服支持"),
          desc: t("专业客服团队，快速响应商户问题<br />多渠道接入，7x12小时在线服务"),
        },
        {
          icon: require("@/assets/help/icon-maintain.svg"),
          title: t("技术运维服务"),
          desc: t("系统实施监控，保障稳定运行<br />专业运维团队，快速定位解决问题"),
        },
        {
          icon: require("@/assets/help/icon-upgrade.svg"),
          title: t("系统升级维护"),
          desc: t("持续功能更新，强化产品体验<br />定期系统维护，确保最佳性能"),
        },
        {
          icon: require("@/assets/help/icon-security.svg"),
          title: t("安全保障"),
          desc: t("多维安全防护，保障数据安全<br />严格权限管理，保护商户隐私"),
        },
      ],
      flowSteps: [
        { num: "01", icon: require("@/assets/help/h5-step-01.png"), title: t("提交问题") },
        { num: "02", icon: require("@/assets/help/h5-step-02.png"), title: t("技术受理") },
        { num: "03", icon: require("@/assets/help/h5-step-03.png"), title: t("问题分析") },
        { num: "04", icon: require("@/assets/help/h5-step-04.png"), title: t("解决处理") },
        { num: "05", icon: require("@/assets/help/h5-step-05.png"), title: t("反馈结果") },
      ],
      guaranteeList: [
        {
          icon: require("@/assets/help/icon-guarantee-stable.svg"),
          value: "99.99%",
          label: t("系统稳定性"),
          desc: t("高可用架构<br />保障系统稳定运行"),
        },
        {
          icon: require("@/assets/help/icon-guarantee-exp.svg"),
          value: "10000+",
          label: t("商户服务经验"),
          desc: t("为1w+商户提供优质服务"),
        },
        {
          icon: require("@/assets/help/icon-guarantee-hour.svg"),
          value: "7x12",
          label: t("小时支持"),
          desc: t("每天9:00-21:00<br />专业技术支持"),
        },
        {
          icon: require("@/assets/help/icon-guarantee-response.svg"),
          value: "<3min",
          label: t("平均响应时间"),
          desc: t("快速响应<br />及时解决问题"),
        },
      ],
    };
  },
  activated() {
    this.$refs.supportH5.scrollIntoView();
  },
  methods: {
    phone() {
      window.location.href = "tel:400-086-1123";
    },
  },
};
</script>

<style lang="less" scoped>
.supportH5 {
  background: #f7fafe;
  width: 750px;
  margin: 0 auto;

  /* Hero Section */
  .hero-section {
    width: 100%;
    background: #f7fafe;
    overflow: hidden;
    padding-bottom: 40px;
    box-sizing: border-box;

    .hero-illustration {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  /* Common Section */
  .section {
    padding: 40px 32px;

    .section-header {
      text-align: center;
      margin-bottom: 32px;
    }

    .section-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 500;
      font-size: 40px;
      line-height: 1.2em;
      color: #04154a;
      margin: 0 0 12px;
    }

    .section-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 24px;
      line-height: 1.43em;
      color: #3d485d;
      margin: 0;
      text-align: center;
    }
  }

  /* Service Section - 2x2 Grid */
  .service-section {
    background: #f7fafe;
    .service-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
    }

    .service-card {
      width: calc(50% - 12px);
      background: #fff;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      box-sizing: border-box;

      .service-icon {
        width: 120px;
        height: 120px;
        border-radius: 80px;
        margin-bottom: 24px;
      }

      .service-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .service-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 36px;
        line-height: 1.33em;
        color: #202d40;
        margin: 0;
      }

      .service-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.67em;
        color: #69717e;
        margin: 0;
      }
    }
  }

  /* Support Section - 3 Column Grid */
  .support-section {
    background: #f7fafe;
    padding-bottom: 0;

    .support-cards {
      display: flex;
      gap: 16px;
    }

    .support-card {
      flex: 1;
      min-width: 0;
      border-radius: 8px;
      padding: 24px 12px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 12px;

      .support-icon {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        flex-shrink: 0;
      }

      .support-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 28px;
        line-height: 1.29em;
        margin: 0;

        &.green {
          color: #09bb07;
        }
        &.purple {
          color: #907fff;
        }
        &.blue {
          color: #336fff;
        }
      }

      .support-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 22px;
        line-height: 1.45em;
        color: #69717e;
        margin: 0;
      }

      .support-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        height: 36px;
        border-radius: 6px;
        font-family: "Noto Sans SC", sans-serif;
        font-size: 22px;
        line-height: 1em;
        padding: 0 16px;
        margin-top: auto;
        cursor: pointer;
        box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);

        &.green-btn {
          background: rgba(9, 187, 7, 0.1);
          border: 1px solid #09bb07;
          color: #09bb07;
        }
      }

      .support-tag {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 24px;
        line-height: 1.33em;
        margin-top: auto;

        &.purple-tag {
          color: #907fff;
        }
        &.blue-tag {
          color: #336fff;
        }
      }
    }

    .wechat-card {
      background: #eaf9f7;
    }

    .ticket-card {
      background: #f7f2ff;
    }

    .phone-card {
      background: #e6f1ff;
    }
  }

  /* Flow Section */
  .flow-section {
    background: #f7fafe;

    .flow-steps {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flow-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      width: 96px;
      flex-shrink: 0;

      .step-icon {
        width: 80px;
        height: 80px;
      }

      .step-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 24px;
        line-height: 1.33em;
        color: #202d40;
        white-space: nowrap;
      }
    }

    .step-arrow {
      width: 24px;
      height: 80px;
      flex-shrink: 0;
      object-fit: contain;
      object-position: center;
    }
  }

  /* Guarantee Section - 2x2 Grid */
  .guarantee-section {
    background: #f7fafe;
    .guarantee-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
    }

    .guarantee-card {
      width: calc(50% - 12px);
      background: #fff;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
      box-sizing: border-box;

      .guarantee-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
      }

      .guarantee-icon {
        width: 80px;
        height: 80px;
        border-radius: 80px;
      }

      .guarantee-value {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 700;
        font-size: 40px;
        line-height: 1.4em;
        color: #336fff;
      }

      .guarantee-label {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 500;
        font-size: 32px;
        line-height: 1.25em;
        color: #202d40;
        margin-bottom: 16px;
      }

      .guarantee-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 26px;
        line-height: 1.38em;
        color: #69717e;
        margin: 0;
      }
    }
  }

  /* Feature Bar - Frame 18495 */
  .feature-bar {
    background: #f7fafe;
    padding: 20px 32px;
    box-sizing: border-box;

    .feature-list {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 80px;
    }

    .feature-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: "Noto Sans SC", sans-serif;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4em;
      color: #002864;

      .feature-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
      }

      span {
        white-space: nowrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/supportH5.vue